export function decifraToken(token) {
  // Decodifica el JWT
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  const data = JSON.parse(jsonPayload);
  return data;
}


export function encryptSession(llave, data) {
  const SECRET_KEY = process.env.VUE_APP_SECRET_KEY;
  if (!SECRET_KEY) {
    throw new Error("SECRET_KEY is not defined");
  }

  const encryptData = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    SECRET_KEY,
  ).toString();

  sessionStorage.setItem(llave, encryptData);

}

export function decryptSession(llave) {
  const SECRET_KEY = process.env.VUE_APP_SECRET_KEY;
  if (!SECRET_KEY) {
    throw new Error("SECRET_KEY is not defined");
  }

  const encryptData = sessionStorage.getItem(llave);

  if(encryptData) {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptData, SECRET_KEY);
      const decryptData = bytes.toString(CryptoJS.enc.Utf8);

      if (!decryptData) {
        throw new Error('Failed to decrypt data');
      }

      return JSON.parse(decryptData);

    } catch(error) {
      console.error('Error during decytion:', error);
      return null;
    }
  } else {
    return null;
  }
}

export const parseDate = (date, monthNames = false) => {
  if (!date) return "";
  if (date.includes("-")) {
    let [year, month, day] = date.split("-");
    let meses = {
      "01": "enero",
      "02": "febrero",
      "03": "marzo",
      "04": "abril",
      "05": "mayo",
      "06": "junio",
      "07": "julio",
      "08": "agosto",
      "09": "septiembre",
      10: "octubre",
      11: "noviembre",
      12: "diciembre",
    };
    return monthNames
      ? `${day} de ${meses[month] || ""} de ${year}`
      : `${day}/${month}/${year}`;
  }
  return date;
};

export const getFechaActual = () => {
  let date = new Date();
  let year = date.getFullYear();
  let month = ("0" + (date.getMonth() + 1)).slice(-2); // Agregar un cero adelante si es necesario
  let day = ("0" + date.getDate()).slice(-2); // Agregar un cero adelante si es necesario
  let formattedDate = year + "-" + month + "-" + day;
  return formattedDate;
};

export const formarDate = (date) => {
  return `${date.getFullYear()}-${("0" + (date.getMonth() + 1)).slice(-2)}-${(
    "0" + date.getDate()
  ).slice(-2)}`;
};

export const operaFecha = (operacion, fecha, dias) => {
  const dateSplitted = fecha.split("-");
  let fechaLimite = "";
  if (operacion === 1)
    fechaLimite = new Date(
      Number(dateSplitted[0]),
      Number(dateSplitted[1] - 1),
      Number(dateSplitted[2]) + dias
    );
  if (operacion === 2)
    fechaLimite = new Date(
      Number(dateSplitted[0]),
      Number(dateSplitted[1] - 1),
      Number(dateSplitted[2]) - dias
    );
  return formarDate(fechaLimite);
};

export function decodifica64(base64, nombre) {
  // Extraer el tipo MIME desde el string base64
  const matches = base64.match(/^data:(.+);base64,(.+)$/);
  if (!matches) {
    console.error("Base64 mal formado");
    return;
  }
  const mimeType = matches[1];
  const base64Data = matches[2];

  // Convertir base64 a un Blob
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  // Crear el Blob con el tipo MIME correcto
  const blob = new Blob([byteArray], { type: mimeType });

  // Crear una URL para el Blob
  const blobUrl = URL.createObjectURL(blob);

  // Crear un enlace para la descarga
  const downloadLink = document.createElement("a");
  downloadLink.href = blobUrl;
  downloadLink.download = nombre;
  document.body.appendChild(downloadLink);
  downloadLink.click();

  // Limpieza
  document.body.removeChild(downloadLink);
  URL.revokeObjectURL(blobUrl);

  //  Logica anterior

  // var pdfURL = base64;

  // // Crear un enlace para la descarga
  // var downloadLink = document.createElement("a");
  // downloadLink.href = pdfURL;
  // downloadLink.download = nombre; // Nombre del archivo al descargar
  // downloadLink.target = "_blank";

  // // Simular un clic en el enlace para iniciar la descarga
  // downloadLink.click();

  // Liberar recursos
  // URL.revokeObjectURL(pdfURL);
}
